import { render, staticRenderFns } from "./SelectCompanyProvider.vue?vue&type=template&id=bedf564c"
import script from "./SelectCompanyProvider.vue?vue&type=script&lang=js"
export * from "./SelectCompanyProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports